export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00097.ae0b38cb.png";